import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-32 pb-16 px-4 sm:px-6 max-w-lg mx-auto text-center" data-testid="payment-cancel">
        <XCircle size={48} className="text-muted-foreground mx-auto mb-5" />
        <h1 className="font-cormorant text-4xl font-semibold text-foreground mb-3">Checkout cancelled</h1>
        <p className="font-manrope text-sm text-muted-foreground mb-8">
          No charge was made. You can come back anytime — or start with the free plan.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/subscribe" data-testid="cancel-retry-btn" className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-brand-accent text-white font-manrope text-sm font-medium hover:bg-brand-accent-hover transition-colors">
            View plans
          </Link>
          <Link to="/" className="inline-flex items-center justify-center px-6 py-3 rounded-full border border-border font-manrope text-sm font-medium text-foreground hover:bg-muted transition-colors">
            Back to home
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
